export default __webpack_public_path__ + "static/media/Mortiferous Boots.41251122.jpg";